import React from 'react';
import { Box, Tooltip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ErrorIcon from '@mui/icons-material/Error';
import { colors } from '../../theme';

interface StatusIconProps {
  delivery_status?: string;
  error_message?: string;
}

/**
 * StatusIcon component that displays delivery status of a message.
 * - 'sent': single gray checkmark
 * - 'delivered': double gray checkmarks
 * - 'read': double blue checkmarks
 * - 'failed': red exclamation mark with tooltip
 */
const StatusIcon = ({ delivery_status, error_message }: StatusIconProps) => {
  if (!delivery_status) return null;

  const ds = delivery_status.toString().toLowerCase();

  let icon = null;
  let iconColor = colors.grey1;
  let tooltipText = '';

  if (ds === 'failed' || ds === 'not_delivered' || ds === 'notdelivered' || ds === 'not-delivered') {
    icon = <ErrorIcon />;
    iconColor = colors.red1;
    tooltipText = error_message ? `Failed: ${error_message}` : 'Failed to deliver';
  } else if (ds === 'delivered') {
    icon = <DoneAllIcon />;
    iconColor = colors.grey1;
    tooltipText = 'Delivered';
  } else if (ds === 'read') {
    icon = <DoneAllIcon />;
    iconColor = colors.blue1;
    tooltipText = 'Read';
  } else if (ds === 'sent') {
    icon = <DoneIcon />;
    iconColor = colors.grey1;
    tooltipText = 'Sent';
  }

  if (!icon) return null;

  return (
    <Tooltip title={tooltipText} arrow>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: '0.3rem',
        }}
      >
        {React.cloneElement(icon as React.ReactElement, {
          sx: {
            fontSize: '0.9rem',
            color: iconColor,
          },
        })}
      </Box>
    </Tooltip>
  );
};

export default StatusIcon;
